import * as React from 'react';

interface LoadingSpinnerProps {
  variant?: 'small' | 'medium';
  color?: 'pink' | 'white' | 'primary';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  variant = 'medium',
  color = 'pink',
}) => {
  return (
    <div className="flex">
      <div className={`loading-spinner ${variant} ${color}`} />
    </div>
  );
};

export default LoadingSpinner;
